import {
	RoleLeaves,
	RoleTree,
	UserRole,
} from '../components/admin/namespace/types';

export const buildRoleTree = (roles: UserRole[]) => {
	const newRoleTree = {} as RoleTree;
	roles.forEach((role) => {
		const isAdmin =
			role.tenantHostname === undefined && role.namespace !== undefined;
		const key = isAdmin ? role.namespace : role.tenantHostname;
		if (!newRoleTree[key]) {
			newRoleTree[key] = {} as RoleLeaves;
			newRoleTree[key].roles = [role];
			newRoleTree[key].label = key;
			newRoleTree[key].isAdmin = isAdmin;
		} else {
			newRoleTree[key].roles.push(role);
		}
	});
	return newRoleTree;
};
